import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloudUploadRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13.6 4.8a8 8 0 0 0-7.965 8.73A7.202 7.202 0 0 0 8.8 27.2H24a6.402 6.402 0 0 0 2.895-12.11 5.998 5.998 0 0 0-7.36-7.655A8 8 0 0 0 13.6 4.8m-5.6 8c0-3.095 2.505-5.6 5.6-5.6 1.885 0 3.55.93 4.565 2.355.335.475.965.64 1.49.39a3.598 3.598 0 0 1 5.14 3.255c0 .705-.2 1.36-.55 1.915-.205.325-.24.73-.1 1.085s.45.625.825.715a4.001 4.001 0 0 1-.975 7.88h-15.2a4.801 4.801 0 0 1-1.47-9.37c.59-.19.94-.8.805-1.405a5.5 5.5 0 0 1-.135-1.225zm8.85.35c-.47-.47-1.23-.47-1.695 0l-3.2 3.2a1.2 1.2 0 0 0 1.695 1.695l1.15-1.15V21.2c0 .665.535 1.2 1.2 1.2s1.2-.535 1.2-1.2v-4.305l1.15 1.15a1.2 1.2 0 0 0 1.695-1.695l-3.2-3.2z" })
});
export default SvgCloudUploadRegularIcon;
